import WorkflowEdge from './WorkflowEdge'

export const edgeTypes = {
  workflow: WorkflowEdge,
}
